import { Box, Container, Grid, Typography } from "@mui/material";
import Circle from "../components/circle";
import ProductCard from "../components/product-card";
import { useEffect, useMemo, useState } from "react";
import { createApiCall } from "../api/api-service";
import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import CommonLabel from "../components/label";
import CommonTextBox from "../components/TextBoxes/common-text-box";
import ChipsBox from "../components/chips-box";
import CommonFilterBox from "../components/filter-box";
import ProductGrid from "../components/product-grid";
import CommonPagination from "../components/pagination/common-pagination";
import CategorySection from "../components/category-section/category-section";
import FOUNDATION from "../assets/icons/foundation.PNG";
import CONCEALER from "../assets/icons/concealer.png";
import COMPACT from "../assets/icons/compact.PNG";
import PRIMER from "../assets/icons/primer.PNG";
import BLUSH from "../assets/icons/blush.PNG";
import MASCARA from "../assets/icons/mascara.PNG";
import EYELINER from "../assets/icons/eyeline.PNG";
import LIPSTICK from "../assets/icons/lipstick.PNG";
import LIP_BALM from "../assets/icons/lip_balm.PNG";
import MAKEUP_BRUSHES from "../assets/icons/makeup_brushes.PNG";
import MAKEUP_REMOVER from "../assets/icons/makerup_remver.PNG";
import NAIL_POLISH from "../assets/icons/nails.PNG";
import FACE_WASH from "../assets/icons/facewash.PNG";
import CLEANSER from "../assets/icons/cleanser.PNG";
import TONER from "../assets/icons/toner.PNG";
import MOISTURIZER from "../assets/icons/moisturizer.PNG";
import SUNSCREEN from "../assets/icons/suncscreen.PNG";
import SERUM from "../assets/icons/serum.PNG";
import FACE_MASK from "../assets/icons/facemask.PNG";
import SHEET_MASK from "../assets/icons/sheet_mask.PNG";
import EYE_CREAM from "../assets/icons/eyecream.PNG";
import FACE_SCRUB from "../assets/icons/face_scrub.PNG";
import BODY_WASH from "../assets/icons/body_wash.PNG";
import SHOWER_GEL from "../assets/icons/shower_gel.PNG";
import BATH_SOAP from "../assets/icons/bath_soap.PNG";
import BODY_SCRUB from "../assets/icons/body_scrub.PNG";
import BODY_LOTION from "../assets/icons/body_lotion.PNG";
import BODY_OIL from "../assets/icons/body_oil.PNG";
import BATH_SALTS from "../assets/icons/bath_salt.PNG";
import HAND_WASH from "../assets/icons/hand_wash.PNG";
import HAND_CREAM from "../assets/icons/hand_cream.PNG";
import SHAMPOO from "../assets/icons/shampoo.PNG";
import CONDITIONER from "../assets/icons/conditioner.PNG";
import HAIR_SERUM from "../assets/icons/hair_serum.PNG";
import HAIR_OIL from "../assets/icons/hair_oil.PNG";
import HAIR_MASK from "../assets/icons/hair_mask.PNG";
import HAIR_GEL from "../assets/icons/hair_gel.PNG";
import HAIR_WAX from "../assets/icons/hair_wax.PNG";
import HAIR_SPRAY from "../assets/icons/hair_spray.PNG";
import HAIR_COLOR from "../assets/icons/hair_color.PNG";
import HAIR_BRUSHES from "../assets/icons/hair_brushes.PNG";
import HAIR_DRYER from "../assets/icons/hair_dryer.PNG";
import HAIR_STRAIGHTENER from "../assets/icons/hair_straightener.PNG";
import HAIR_CURLER from "../assets/icons/hair_curler.PNG";
import MENSTRUAL_CUP from "../assets/icons/menstrual_cup.PNG";
import SANITARY_PADS from "../assets/icons/sanitary_pads.PNG";
import TAMPONS from "../assets/icons/tampons.PNG";
import PANTY_LINERS from "../assets/icons/panty_liners.PNG";
import INTIMATE_WASH from "../assets/icons/intimate_wash.PNG";
import INTIMATE_WIPES from "../assets/icons/intimate_wipes.PNG";
import PREGNANCY_TEST_KIT from "../assets/icons/pregancy_test_kit.PNG";
import OVULATION_TEST_KIT from "../assets/icons/ovulation_test_kit.PNG";
import BB_CREAM from "../assets/icons/bb_cream.PNG";
import BROW from "../assets/icons/brow.PNG";
import CONTOUR from "../assets/icons/contour.PNG";
import EYE_SHADOW from "../assets/icons/eye_shadow.PNG";
import HIGHLIGHTER from "../assets/icons/highlighter.PNG";
import KAJAL from "../assets/icons/kajal.PNG";
import LIP_GLOSS from "../assets/icons/lip_gloss.PNG";
import SETTING_SPRAY from "../assets/icons/setting_spray.PNG";
import MISCELLANEOUS from "../assets/icons/miscellaneous.PNG";


const CategoryPage = () => {
  // const { category } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("sub");
  const [currentPage, setCurrentPage] = useState(1);
  const categoryList = [
    {
      category_id: "cat_1",
      category_name: "Foundation",
      category_image: FOUNDATION,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_2",
      category_name: "Concealer",
      category_image: CONCEALER,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_3",
      category_name: "Compact",
      category_image: COMPACT,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_3",
      category_name: "Eye Shadow",
      category_image: EYE_SHADOW,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "Eye Shadow",
      category_image: EYE_SHADOW,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "Highlighter",
      category_image: HIGHLIGHTER,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "Contour",
      category_image: CONTOUR,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "BB Cream",
      category_image: BB_CREAM,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "Setting Spray",
      category_image: SETTING_SPRAY,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "Lip Gloss",
      category_image: LIP_GLOSS,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "Kajal",
      category_image: KAJAL,
      main_category_name: "beauty",
    },
    {
      category_id: "",
      category_name: "Brow",
      category_image: BROW,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_4",
      category_name: "Primer",
      category_image: PRIMER,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_5",
      category_name: "Blush",
      category_image: BLUSH,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_6",
      category_name: "Mascara",
      category_image: MASCARA,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_7",
      category_name: "Eyeliner",
      category_image: EYELINER,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_8",
      category_name: "Lipstick",
      category_image: LIPSTICK,
      main_category_name: "beauty",
    },
    ]
    let x=[
      {
      category_id: "cat_9",
      category_name: "Lip Balm",
      category_image: LIP_BALM,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_10",
      category_name: "Makeup Brushes",
      category_image: MAKEUP_BRUSHES,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_11",
      category_name: "Makeup Remover",
      category_image: MAKEUP_REMOVER,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_12",
      category_name: "Nail",
      category_image: NAIL_POLISH,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_12",
      category_name: "Nail Polish",
      category_image: NAIL_POLISH,
      main_category_name: "beauty",
    },
    {
      category_id: "cat_13",
      category_name: "Face Wash",
      category_image: FACE_WASH,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_14",
      category_name: "Cleanser",
      category_image: CLEANSER,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_15",
      category_name: "Toner",
      category_image: TONER,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_16",
      category_name: "Moisturizer",
      category_image: MOISTURIZER,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_17",
      category_name: "BB Cream",
      category_image: BB_CREAM,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_17",
      category_name: "Sunscreen",
      category_image: SUNSCREEN,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_18",
      category_name: "Serum",
      category_image: SERUM,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_19",
      category_name: "Face Mask",
      category_image: FACE_MASK,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_20",
      category_name: "Sheet Mask",
      category_image: SHEET_MASK,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_21",
      category_name: "Eye Cream",
      category_image: EYE_CREAM,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_23",
      category_name: "Face Scrub",
      category_image: FACE_SCRUB,
      main_category_name: "skincare",
    },
    {
      category_id: "cat_24",
      category_name: "Body Wash",
      category_image: BODY_WASH,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_25",
      category_name: "Shower Gel",
      category_image: SHOWER_GEL,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_26",
      category_name: "Bath Soap",
      category_image: BATH_SOAP,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_27",
      category_name: "Body Scrub",
      category_image: BODY_SCRUB,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_28",
      category_name: "Body Lotion",
      category_image: BODY_LOTION,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_29",
      category_name: "Body Oil",
      category_image: BODY_OIL,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_30",
      category_name: "Bath Salts",
      category_image: BATH_SALTS,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_32",
      category_name: "Hand Wash",
      category_image: HAND_WASH,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_33",
      category_name: "Hand Cream",
      category_image: HAND_CREAM,
      main_category_name: "bath & spa",
    },
    {
      category_id: "cat_34",
      category_name: "Shampoo",
      category_image: SHAMPOO,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_35",
      category_name: "Conditioner",
      category_image: CONDITIONER,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_36",
      category_name: "Hair Serum",
      category_image: HAIR_SERUM,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_37",
      category_name: "Hair Oil",
      category_image: HAIR_OIL,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_38",
      category_name: "Hair Mask",
      category_image: HAIR_MASK,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_39",
      category_name: "Hair Gel",
      category_image: HAIR_GEL,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_40",
      category_name: "Hair Wax",
      category_image: HAIR_WAX,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_41",
      category_name: "Hair Spray",
      category_image: HAIR_SPRAY,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_43",
      category_name: "Hair Color",
      category_image: HAIR_COLOR,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_44",
      category_name: "Hair Brushes",
      category_image: HAIR_BRUSHES,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_45",
      category_name: "Hair Dryer",
      category_image: HAIR_DRYER,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_46",
      category_name: "Hair Straightener",
      category_image: HAIR_STRAIGHTENER,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_47",
      category_name: "Hair Curler",
      category_image: HAIR_CURLER,
      main_category_name: "hair styling",
    },
    {
      category_id: "cat_50",
      category_name: "Menstrual Cup",
      category_image: MENSTRUAL_CUP,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_51",
      category_name: "Sanitary Pads",
      category_image: SANITARY_PADS,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_52",
      category_name: "Tampons",
      category_image: TAMPONS,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_53",
      category_name: "Panty Liners",
      category_image: PANTY_LINERS,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_54",
      category_name: "Intimate Wash",
      category_image: INTIMATE_WASH,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_55",
      category_name: "Intimate Wipes",
      category_image: INTIMATE_WIPES,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_56",
      category_name: "Pregnancy Test Kit",
      category_image: PREGNANCY_TEST_KIT,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_57",
      category_name: "Ovulation Test Kit",
      category_image: OVULATION_TEST_KIT,
      main_category_name: "sexual wellness",
    },
    {
      category_id: "cat_58",
      category_name: "Miscellaneous",
      category_image: MISCELLANEOUS,
      main_category_name: "miscellaneous",
    },
  ];
  const filterSections = [
    {
      key: "price",
      header: "Price",
      values: [" ₹ 10 - 399", "₹ 400 - 699", "₹ 700 - 999", "Above ₹999"],
      type: "radio",
    },
    {
      key: "coo",
      header: "Country Of Origin",
      values: ["India", "China", "Germeny", "USA", "Korea"],
      type: "radio",
    },
    {
      key: "availability",
      header: "Availability",
      values: ["In Stock", "Out of Stock"],
      type: "radio",
    },
  ];
  const fetchCategoryListData = async () => {
    const data = await createApiCall("GET", "inventory/fetch_category");
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    return Object.values(data);
  };

  // const fetchCategoryFilters = async () => {
  //   const data = await createApiCall("POST", "inventory/fetch_category_filters", {
  //     category_name: category,
  //   });
  //   return data || [];
  // };
  const filterValues = useMemo(
    () => Object.fromEntries([...searchParams]),
    [searchParams],
  );
  const searchParamsString = searchParams.toString();

  const fetchProductData = async (page = 1) => {
    const payload = {
      category_name: category,
      page,
      page_size: 20,
      ...filterValues,
    };

    const data = await createApiCall(
      "POST",
      "inventory/fetch_categroy_wise_product",
      payload,
      true,
    );
    return data || {};
  };

  // const {
  //   data: categoryList,
  //   isLoading: isCategoryLoading,
  //   isError: isCategoryError,
  // } = useQuery({
  //   queryKey: ["categories", "list"],
  //   queryFn: fetchCategoryListData,
  //   staleTime: 5 * 60 * 1000,
  //   retry: 1,
  // });

  const {
    data: productData = {},
    isLoading: isProductLoading,
    isError: isProductError,
  } = useQuery({
    queryKey: [
      "categories",
      category,
      "products",
      currentPage,
      searchParamsString,
    ],
    queryFn: () => fetchProductData(currentPage),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    keepPreviousData: true,
  });

  // const {
  //   data: filterSections,
  //   isLoading: isFilterLoading,
  //   isError: isFilterError,
  // } = useQuery({
  //   queryKey: ["categories", "explore", category],
  //   queryFn: fetchCategoryFilters,
  //   staleTime: "infinte",
  //   retry: 1,
  // });
  const products = productData?.data || [];
  const productCount = productData?.pagination || {};

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  if (isProductLoading) {
    return <>Loading...</>;
  }

  if (isProductError) {
    return <>Failed to load category data.</>;
  }

  return (
    <Container sx={{ py: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CommonLabel variant={"h5"}>Categories</CommonLabel>
        {/* <Box>
          <CommonTextBox placeholder={"Search Product ..."} />
        </Box> */}
      </Box>

      <CategorySection category={categoryList} />

      <Box sx={{ display: "flex", marginTop: "10px", gap: 7 }}>
        <Box
          sx={{
            display: { xs: "none", sm: "none", md: "block", lg: "block" },
            width: "20%",
          }}
        >
          <CommonFilterBox
            title="Filters"
            sections={filterSections}
            onFilterChange={(e) => {
              setCurrentPage(1);
              const currentParams = Object.fromEntries([...searchParams]);
              const nextParams = Object.entries({
                ...currentParams,
                ...e,
              }).reduce((acc, [key, value]) => {
                acc[key] = Array.isArray(value) ? value.join(",") : value;
                return acc;
              }, {});
              setSearchParams(nextParams);
            }}
          />
        </Box>
        <Box
          sx={{
            display: { md: "block", lg: "block" },
            width: { xs: '100%', ms: "80%" },
          }}
        >
          <CommonPagination
            page={productCount?.page || 1}
            totalPages={productCount?.total_pages || 1}
            pageSize={productCount?.page_size || 20}
            totalCount={productCount?.total_count || 0}
            onPageChange={handlePageChange}
            showResultCount={true}
          />
          <Box sx={{ mb: "10px" }}>
            <ProductGrid productList={products} />
          </Box>
        </Box>
      </Box>
      {/* Horizontal Scrollable Categories */}
      {/* <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: '100%',
          overflowX: 'auto',
          alignItems: 'center',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' } // Hide scrollbar on WebKit
        }}
      >
        {categoryList.map((value, index) => (
          <Circle
            key={index}
            categoryUrl={`/category/${value?.category_name}`}
            content={value?.category_image}
            text={value?.category_name}
            highlight = {category === value?.category_name}
          />
        ))}
      </Box>

      {/* Header Row */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, mb: 1 }}>
        <Typography variant="h6">{category.toLocaleUpperCase()}</Typography>
        <Typography variant="body2" color="text.secondary">{productsLength} Products</Typography>
      </Box> */}

      {/* Product Grid */}
      {/* <Grid container spacing={2}>
        {products.map((item, index) => {
          
          return (
            <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
              <ProductCard
                cardUrl={item?.variant_url}
                cardText={item?.variant_name}
                cardImage={item?.variant_image}
              />
            </Grid>
          );
        })}
      </Grid> */}
    </Container>
  );
};

export default CategoryPage;
